import { createEffect } from 'effector';
import { api } from '../../api/axiosinstance.js';

export const getABCountriesFx = createEffect().use(async () => {
  return (await api().get(`trademap/countries`)).data;
});

export const getABHSCodesFx = createEffect().use(async () => {
  return (await api().get(`trademap/hscodes`)).data;
});

export const getABCountriesHSDataFx = createEffect().use(async (hscode) => {
  return (await api().get(`trademap/${hscode}`)).data;
});
